import api from './api';

const authService = {
    async login(username, password, userType) {
        const response = await api.post('/login', { username, password, user_type: userType });
        if (response.data.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            // Which pricing model the server is running. Drives whether the
            // region screens are shown; see services/rateEngine.js.
            localStorage.setItem('rate_engine', response.data.rate_engine || 'legacy');
        }
        return response.data;
    },

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('rate_engine');
    },

    getCurrentUser() {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    },

    getUserType() {
        const user = this.getCurrentUser();
        return user?.type;
    },

    hasPermission(permission) {
        const user = this.getCurrentUser();
        
        // Check if user exists and has role
        if (!user || !user.role) {
            return false;
        }
        
        // If admin, allow everything
        if (user.role.name === 'Administrator' || user.role.slug === 'admin') {
            return true;
        }
        
        // Check if permissions is an array of permission objects or strings
        const permissions = user.role.permissions || [];
        
        // Handle both formats: array of objects with permission_slug or array of strings
        return permissions.some(perm => {
            if (typeof perm === 'object') {
                return perm.permission_slug === permission || perm.slug === permission;
            }
            return perm === permission;
        });
    },

    isAdmin() {
        const user = this.getCurrentUser();
        return user?.role?.name === 'Administrator' || user?.role?.slug === 'admin';
    },

    canViewRevenue() {
        return this.isAdmin() || this.hasPermission('view-revenue');
    }
};

export default authService;